document.addEventListener('DOMContentLoaded', function () {
  initCustomDropdowns();
});

function initCustomDropdowns() {
  const dropdowns = document.querySelectorAll('.custom-dropdown');

  dropdowns.forEach(function (dropdown) {
    if (!dropdown.dataset.targetSelect) return;

    const trigger = dropdown.querySelector('.custom-dropdown__trigger');
    const menu = dropdown.querySelector('.custom-dropdown__menu');
    const items = dropdown.querySelectorAll('.custom-dropdown__item');
    const label = dropdown.querySelector('.custom-dropdown__label');
    const targetSelectId = dropdown.dataset.targetSelect;
    const targetSelect = document.getElementById(targetSelectId);
    const isStatic = dropdown.dataset.static === 'true';

    if (!trigger) return;

    if (isStatic) {
      if (targetSelect && items.length === 1) {
        const value = items[0].dataset.value;
        targetSelect.value = value;
      }
      return;
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = dropdown.dataset.open === 'true';

      document.querySelectorAll('.custom-dropdown[data-open="true"]').forEach(function (d) {
        if (d !== dropdown) {
          d.dataset.open = 'false';
          const t = d.querySelector('.custom-dropdown__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });

      dropdown.dataset.open = isOpen ? 'false' : 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const value = item.dataset.value;

        if (label) label.textContent = value;

        items.forEach(function (i) {
          i.classList.remove('custom-dropdown__item--selected');
          i.removeAttribute('aria-selected');
        });
        item.classList.add('custom-dropdown__item--selected');
        item.setAttribute('aria-selected', 'true');

        dropdown.classList.remove('custom-dropdown--unselected');
        dropdown.dataset.hasSelection = 'true';

        if (targetSelect) {
          targetSelect.value = value;
          targetSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        dropdown.dataset.open = 'false';
        trigger.setAttribute('aria-expanded', 'false');

        checkAllDropdownsSelected();
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      });
    });

    if (items.length === 1) {
      const singleItem = items[0];
      const value = singleItem.dataset.value;

      if (label) label.textContent = value;

      singleItem.classList.add('custom-dropdown__item--selected');
      singleItem.setAttribute('aria-selected', 'true');

      dropdown.classList.remove('custom-dropdown--unselected');
      dropdown.dataset.hasSelection = 'true';

      if (targetSelect) {
        targetSelect.value = value;
        targetSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.custom-dropdown')) {
      document.querySelectorAll('.custom-dropdown[data-open="true"]').forEach(function (d) {
        d.dataset.open = 'false';
        const t = d.querySelector('.custom-dropdown__trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.querySelectorAll('variant-picker').forEach(function (picker) {
    const pickerDropdowns = picker.querySelectorAll('.custom-dropdown[data-target-select]');
    if (pickerDropdowns.length > 0) setupAddToCartSelectSize(picker);
  });
  resetPreselectedMainPicker();
  checkAllDropdownsSelected();
}

function resetPreselectedMainPicker() {
  const pickers = document.querySelectorAll('variant-picker[data-template-product-match="true"]');

  pickers.forEach(function (picker) {
    const dropdowns = picker.querySelectorAll('.custom-dropdown[data-target-select]');
    if (dropdowns.length === 0) return;

    let didReset = false;

    dropdowns.forEach(function (dropdown) {
      if (dropdown.dataset.static === 'true') return;

      const optionName = dropdown.dataset.optionDisplayName || dropdown.dataset.optionName || '';
      const label = dropdown.querySelector('.custom-dropdown__label');
      const targetSelect = document.getElementById(dropdown.dataset.targetSelect);

      if (dropdown.dataset.hasSelection === 'true' || (targetSelect && targetSelect.value !== '')) {
        didReset = true;
      }

      if (label) label.textContent = optionName;
      dropdown.classList.add('custom-dropdown--unselected');
      dropdown.dataset.hasSelection = 'false';

      dropdown.querySelectorAll('.custom-dropdown__item').forEach(function (i) {
        i.classList.remove('custom-dropdown__item--selected');
        i.removeAttribute('aria-selected');
      });

      if (targetSelect) {
        let emptyOption = targetSelect.querySelector('option[value=""]');
        if (!emptyOption) {
          emptyOption = document.createElement('option');
          emptyOption.value = '';
          emptyOption.textContent = optionName;
          targetSelect.insertBefore(emptyOption, targetSelect.firstChild);
        }
        Array.from(targetSelect.options).forEach(function (opt) {
          opt.removeAttribute('selected');
        });
        emptyOption.setAttribute('selected', 'selected');
        targetSelect.value = '';
      }
    });

    picker.dataset.requireAllOptions = 'true';

    if (didReset) {
      const url = new URL(window.location.href);
      if (url.searchParams.has('variant')) {
        url.searchParams.delete('variant');
        history.replaceState({}, '', url.toString());
      }
    }
  });
}

function setupAddToCartSelectSize(picker) {
  const sectionId = picker.dataset.sectionId;
  const addToCartBtn = document.querySelector(
    '[data-section-id="' + sectionId + '"] button[name="add"], #ProductSubmitButton-' + sectionId + ', .product-form__submit'
  );
  if (!addToCartBtn || addToCartBtn.dataset.selectSizeHandler === 'true') return;
  addToCartBtn.dataset.selectSizeHandler = 'true';

  addToCartBtn.addEventListener(
    'click',
    function (e) {
      const dropdowns = picker.querySelectorAll('.custom-dropdown[data-target-select]');
      if (dropdowns.length === 0) return;

      const hasMultipleOptions = Array.from(dropdowns).some(function (d) {
        const items = d.querySelectorAll('.custom-dropdown__item');
        return items.length > 1;
      });

      if (!hasMultipleOptions) return;

      const allSelected = Array.from(dropdowns).every(function (d) {
        return d.dataset.hasSelection === 'true';
      });
      if (!allSelected) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const firstUnselected = Array.from(dropdowns).find(function (d) {
          return d.dataset.hasSelection !== 'true';
        });
        if (firstUnselected) {
          document.querySelectorAll('.custom-dropdown[data-open="true"]').forEach(function (d) {
            d.dataset.open = 'false';
            const t = d.querySelector('.custom-dropdown__trigger');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
          firstUnselected.dataset.open = 'true';
          const trig = firstUnselected.querySelector('.custom-dropdown__trigger');
          if (trig) {
            trig.setAttribute('aria-expanded', 'true');
            trig.focus();
          }
        }
      }
    },
    true
  );
}

function checkAllDropdownsSelected() {
  const variantPickers = document.querySelectorAll('variant-picker');

  variantPickers.forEach(function (picker) {
    const dropdowns = picker.querySelectorAll('.custom-dropdown[data-target-select]');
    if (dropdowns.length === 0) return;

    const allSelected = Array.from(dropdowns).every(function (d) {
      return d.dataset.hasSelection === 'true';
    });

    const hasMultipleOptions = Array.from(dropdowns).some(function (d) {
      const items = d.querySelectorAll('.custom-dropdown__item');
      return items.length > 1;
    });

    const sectionId = picker.dataset.sectionId;
    const addToCartBtn = document.querySelector(
      '[data-section-id="' + sectionId + '"] button[name="add"], #ProductSubmitButton-' + sectionId + ', .product-form__submit'
    );
    const textEl = addToCartBtn ? addToCartBtn.querySelector('.add-to-cart-text__content') : null;
    const selectSizeText = picker.dataset.selectSizeText || 'Select size';
    const selectOptionTemplate = picker.dataset.selectOptionTemplate || 'Select __OPTION_NAME__';
    const addToCartInStockText = picker.dataset.addToCartInStockText || 'Add To Cart | In Stock';
    const notifyWhenAvailableText = picker.dataset.notifyWhenAvailableText || 'Mail me when available';

    const productForm = document.querySelector('product-form-component[data-section-id="' + sectionId + '"]');
    const madeToOrderText = productForm ? productForm.dataset.madeToOrderButtonText : null;
    const isMadeToOrder = productForm ? productForm.dataset.availability === 'made-to-order' : false;

    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('btn--disabled');
      if (textEl) {
        if (!hasMultipleOptions || allSelected) {
          if (addToCartBtn.dataset.notifyFormSection) {
            textEl.textContent = notifyWhenAvailableText;
          } else if (isMadeToOrder && madeToOrderText) {
            textEl.textContent = madeToOrderText;
          } else {
            textEl.textContent = addToCartInStockText;
          }
        } else {
          const firstUnselected = Array.from(dropdowns).find(function (d) {
            const items = d.querySelectorAll('.custom-dropdown__item');
            return d.dataset.hasSelection !== 'true' && items.length > 1;
          });
          const optionName = firstUnselected ? (firstUnselected.dataset.optionName || '').toLowerCase() : '';
          const isSizeOption = optionName && optionName.indexOf('size') !== -1;
          textEl.textContent =
            optionName && !isSizeOption
              ? selectOptionTemplate.replace('__OPTION_NAME__', optionName)
              : selectSizeText;
        }
      }
    }
  });
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initCustomDropdowns);
}
